export function flatten(values) {
  return values.reduce(function (a, b) {
    return a.concat(b);
  }, []);
}


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-shared/dist/esm/flatten.js
// module id = 63
// module chunks = 0